/**
 * Labstep
 */

import { GridBatchCreateResourceItemsService } from 'labstep-web/grid/BatchCreateResourceItems/services/grid-batch-create-resource-items-service';
import { GridEntityImportService } from 'labstep-web/grid/EntityImport/services/grid-entity-import.service';
import { GridNewIndexService } from 'labstep-web/grid/NewIndex/services/grid-new-index.service';
import { GridReportService } from 'labstep-web/grid/Report/services/grid-report.service';
import { GridSmartTableProtocolConditionService } from 'labstep-web/grid/SmartTableProtocolCondition/services/grid-smart-table-protocol-condition.service';
import { GridSmartTableProtocolValueService } from 'labstep-web/grid/SmartTableProtocolValue/services/grid-smart-table-protocol-value.service';
import { GridService } from 'labstep-web/grid/services/grid.service';
import { useContext, useEffect, useState } from 'react';
import { DataGridContext } from '.';
import type { DataGridContextType } from './types';

export const useDataGridContext = (): DataGridContextType => {
  const context = useContext(DataGridContext);
  if (!context) {
    throw new Error(
      'useDataGridContext must be used within a DataGridContextProvider',
    );
  }
  return context;
};

export const useGridServiceFromContext = ():
  | GridService
  | undefined => {
  const dataGridContext = useDataGridContext();

  const [gridService, setGridService] = useState<GridService>();

  useEffect(() => {
    if (
      dataGridContext?.agGrid?.api &&
      dataGridContext?.agGrid?.columnApi
    ) {
      setGridService(new GridService(dataGridContext.agGrid));
    }
  }, [
    dataGridContext?.agGrid?.api,
    dataGridContext?.agGrid?.columnApi,
  ]);

  return gridService;
};

export const useGridEntityImportServiceFromContext = ():
  | GridEntityImportService
  | undefined => {
  const dataGridContext = useDataGridContext();

  const [gridService, setGridService] =
    useState<GridEntityImportService>();

  useEffect(() => {
    if (
      dataGridContext?.agGrid?.api &&
      dataGridContext?.agGrid?.columnApi
    ) {
      setGridService(
        new GridEntityImportService(dataGridContext.agGrid),
      );
    }
  }, [
    dataGridContext?.agGrid?.api,
    dataGridContext?.agGrid?.columnApi,
  ]);

  return gridService;
};

export const useGridReportServiceFromContext = ():
  | GridReportService
  | undefined => {
  const dataGridContext = useDataGridContext();

  const [gridService, setGridService] = useState<GridReportService>();

  useEffect(() => {
    if (
      dataGridContext?.agGrid?.api &&
      dataGridContext?.agGrid?.columnApi
    ) {
      setGridService(new GridReportService(dataGridContext.agGrid));
    }
  }, [
    dataGridContext?.agGrid?.api,
    dataGridContext?.agGrid?.columnApi,
  ]);

  return gridService;
};

export const useGridNewIndexServiceFromContext = ():
  | GridNewIndexService
  | undefined => {
  const dataGridContext = useDataGridContext();

  const [gridService, setGridService] =
    useState<GridNewIndexService>();

  useEffect(() => {
    if (
      dataGridContext?.agGrid?.api &&
      dataGridContext?.agGrid?.columnApi
    ) {
      setGridService(new GridNewIndexService(dataGridContext.agGrid));
    }
  }, [
    dataGridContext?.agGrid?.api,
    dataGridContext?.agGrid?.columnApi,
  ]);

  return gridService;
};

export const useGridSmartTableProtocolConditionServiceFromContext =
  (): GridSmartTableProtocolConditionService | undefined => {
    const dataGridContext = useDataGridContext();

    const [gridService, setGridService] =
      useState<GridSmartTableProtocolConditionService>();

    useEffect(() => {
      if (
        dataGridContext?.agGrid?.api &&
        dataGridContext?.agGrid?.columnApi
      ) {
        setGridService(
          new GridSmartTableProtocolConditionService(
            dataGridContext.agGrid,
          ),
        );
      }
    }, [
      dataGridContext?.agGrid?.api,
      dataGridContext?.agGrid?.columnApi,
    ]);

    return gridService;
  };

export const useGridSmartTableProtocolValueServiceFromContext = ():
  | GridSmartTableProtocolValueService
  | undefined => {
  const dataGridContext = useDataGridContext();

  const [gridService, setGridService] =
    useState<GridSmartTableProtocolValueService>();

  useEffect(() => {
    if (
      dataGridContext?.agGrid?.api &&
      dataGridContext?.agGrid?.columnApi
    ) {
      setGridService(
        new GridSmartTableProtocolValueService(
          dataGridContext.agGrid,
        ),
      );
    }
  }, [
    dataGridContext?.agGrid?.api,
    dataGridContext?.agGrid?.columnApi,
  ]);

  return gridService;
};

export const useGridBatchCreateResourceItemsServiceFromContext = ():
  | GridBatchCreateResourceItemsService
  | undefined => {
  const dataGridContext = useDataGridContext();

  const [gridService, setGridService] =
    useState<GridBatchCreateResourceItemsService>();

  useEffect(() => {
    if (
      dataGridContext?.agGrid?.api &&
      dataGridContext?.agGrid?.columnApi
    ) {
      setGridService(
        new GridBatchCreateResourceItemsService(
          dataGridContext.agGrid,
        ),
      );
    }
  }, [
    dataGridContext?.agGrid?.api,
    dataGridContext?.agGrid?.columnApi,
  ]);

  return gridService;
};
